import type { TOC } from '@ember/component/template-only';
import SettingsRecommendationsRoomHierarchy from 'lumen/components/settings/recommendations/room-hierarchy';
import type HotelSettingsRecommendationsRoomHierarchyRoute from 'lumen/routes/hotel/settings/recommendations/room-hierarchy';
import type { ModelFrom } from 'lumen/utils/routes';

interface HotelSettingsRecommendationsRoomHierarchySignature {
  Args: {
    controller: unknown;
    model: ModelFrom<HotelSettingsRecommendationsRoomHierarchyRoute>;
  };
}

<template>
  <SettingsRecommendationsRoomHierarchy @model={{@model}} />
</template> satisfies TOC<HotelSettingsRecommendationsRoomHierarchySignature>;
